import { get } from './masClient';
import errorHandler from './errorHandler';
import { ReadMasStatusResponse } from '../types/ReadMasStatusResponse';

export default async (accessToken: string): Promise<ReadMasStatusResponse> =>
  get(`/v1/admin/status`, accessToken).catch(errorHandler);
